/**
 * In-memory dedupe + short TTL cache for read-only GET actions.
 * Cleared on logout via clearApiResponseCaches().
 */

const stores = new Map();

function getStore(name) {
  if (!stores.has(name)) {
    stores.set(name, { data: null, at: 0, inflight: null });
  }
  return stores.get(name);
}

export function cachedGet(key, fetcher, ttlMs = 60000) {
  const store = getStore(key);
  const now = Date.now();

  if (store.data && now - store.at < ttlMs) {
    return Promise.resolve(store.data);
  }

  if (store.inflight) {
    return store.inflight;
  }

  store.inflight = fetcher()
    .then((data) => {
      store.data = data;
      store.at = Date.now();
      store.inflight = null;
      return data;
    })
    .catch((err) => {
      store.inflight = null;
      throw err;
    });

  return store.inflight;
}

export function clearApiResponseCaches() {
  stores.forEach((store) => {
    store.data = null;
    store.at = 0;
    store.inflight = null;
  });
}
